export default "__VITE_ASSET__Dm1UjO2f__"